import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ChangeUserDetailsRequest } from '@vi-iot/client';

import { UserDetailsActions } from './user-details.actions';
import { GatewayViewModel } from './user-details.model';
import { UserDetailsSelectors } from './user-details.selectors';

@Injectable({ providedIn: 'root' })
export class UserDetailsStore {
  state$ = this.store.select(UserDetailsSelectors.getUserDetails());
  companyName$ = this.store.select(UserDetailsSelectors.getUserCompanyName());
  userRoles$ = this.store.select(UserDetailsSelectors.getUserRoles());
  companyNumber$ = this.store.select(UserDetailsSelectors.getCompanyNumber);
  companyAddressForFlatRate$ = this.store.select(UserDetailsSelectors.companyAddressForFlatRate);
  isUserDetailsGatewayError$ = this.store.select(UserDetailsSelectors.isUserDetailsGatewayError());

  constructor(public store: Store) {}

  // eslint-disable-next-line
  getUserRole() {
    return this.store.select(UserDetailsSelectors.getUserRole());
  }

  // eslint-disable-next-line
  getUser() {
    return this.store.select(UserDetailsSelectors.getUser());
  }

  isUserActive(): Observable<boolean> {
    return this.store.select(UserDetailsSelectors.isUserActive());
  }

  isEmailVerified(): Observable<boolean> {
    return this.store.select(UserDetailsSelectors.isEmailVerified());
  }

  userHasAccessToInvitations(): Observable<boolean> {
    return this.store.select(UserDetailsSelectors.userHasAccessToInvitations());
  }

  // eslint-disable-next-line
  getUserContact() {
    return this.store.select(UserDetailsSelectors.getUserContact());
  }

  // eslint-disable-next-line
  getUserAddress() {
    return this.store.select(UserDetailsSelectors.getUserAddress());
  }

  getUserGateways(): Observable<GatewayViewModel> {
    return this.store.select(UserDetailsSelectors.getUserGateways());
  }

  getUserDetails(userId: string): void {
    this.store.dispatch(UserDetailsActions.getUserDetails({ userId }));
  }

  getUserInstallations(limit: number, cursor: string, userDetails: any): void {
    this.store.dispatch(
      UserDetailsActions.getUserInstallations({
        userId: userDetails.id,
        limit,
        cursor,
        userDetails,
      })
    );
  }

  getUserCompany(customerNumber: string): void {
    this.store.dispatch(UserDetailsActions.getUserCompany({ customerNumber }));
  }

  changeUserDetails(body: ChangeUserDetailsRequest): void {
    this.store.dispatch(UserDetailsActions.changeUserDetails({ body }));
  }

  initUserDetailsChange(): void {
    this.store.dispatch(UserDetailsActions.initUserDetailsChange());
  }

  requestPasswordReset(loginId: string): void {
    this.store.dispatch(UserDetailsActions.requestPasswordReset({ loginId }));
  }

  resendConfirmationEmail(loginId: string): void {
    this.store.dispatch(UserDetailsActions.resendConfirmationEmail({ loginId }));
  }
}
